import { useContext } from "react";
import { Stack, StackItem, Text } from "@fluentui/react";
import { MenuDropdown } from "../dropdown/menu.component"
import { GlobalContext } from "../../hooks/globalContext";
import { ArrowNext16Filled, ArrowPrevious16Filled } from "@fluentui/react-icons";
import { Button, Caption1, MenuButton, MenuList, MenuItem } from "@fluentui/react-components";

interface iPagination {
  setCurrentPageNo: any;
  currentPageNo: any;
  totalPages: any;
  defaultSelected?: any,
  setLoading?: any
};

export const Pagination = (props: iPagination) => {
  const { setCurrentPageNo, currentPageNo, totalPages } = props;
  const { defaultSelected, setLoading, } = props || {};
  const contextValue = useContext(GlobalContext);
  const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);

  const texts = (text: any) => (<Stack tokens={{ childrenGap: 3 }}><StackItem><Text /></StackItem><Caption1>{text}</Caption1></Stack>);

  const Navs = ({ position, disabled, link, children }) => (
    <Button shape="circular" size="small" disabled={disabled}
      icon={position === "next" ? <ArrowNext16Filled /> : <ArrowPrevious16Filled />}
      iconPosition={position === "next" ? "after" : "before"}
      onClick={() => {
        setLoading(true); setCurrentPageNo(link);
        defaultSelected === undefined && setTimeout(() => contextValue.setSelectedRowIdInTable([]), 0);
      }}
    >
      <Caption1> {children} </Caption1>
    </Button>
  );

  return (
    <Stack tokens={{ childrenGap: 10 }} horizontal>
      <Navs position="previous" disabled={currentPageNo === 1} link={currentPageNo - 1}> Previous </Navs>
      {texts(`Page`)}
      <StackItem>
        <MenuDropdown
          btn={<MenuButton shape="circular" size="small"> {currentPageNo} </MenuButton>}
          itemVal={
            <MenuList style={{ maxHeight: '50vh' }}>
              {pageNumbers.map((val: any, i: any) => <MenuItem key={i} onClick={() => {setCurrentPageNo(val); setLoading(true)}}>
                <Caption1> {val} </Caption1>
              </MenuItem>)}
            </MenuList>
          }
        />
      </StackItem>
      {texts(`out of ${pageNumbers.length}`)}
      <Navs position="next" disabled={currentPageNo === pageNumbers.length} link={currentPageNo + 1}> Next </Navs>
    </Stack>
  );
};
